import { useState, useEffect, useCallback } from 'react';
import { axiosApi } from '../../api/setupApi';

function useNisMasterlist(year) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNisMasterlist = useCallback(async () => {
    if (!year) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const { data } = await axiosApi.get(`/nisMasterlist/nested/${year}`);
      setData(data);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchNisMasterlist();
  }, [fetchNisMasterlist]);

  return { data, loading, error, refetch: fetchNisMasterlist };
}

export default useNisMasterlist;
